import axios from "../../config/axiosConfig";

export default {
  get: (params) => axios.get(`/appointments/get?location=${params}`),
  add: (data) => axios.post("/appointment/add", data),
  update: (data) => axios.post("/appointment/update", data),
  remove: (data) => axios.post("/appointment/remove", data),
  copy: (id) => axios.get(`/appointments/copy?location=${id}`), // copy appointments to next week
};
